<template>
  <div>
    <van-empty
      image="error"
      :description="errValue"
    >

      <div style="margin-bottom:10px">
        <van-button
          round
          type="danger"
          class="bottom-button"
          @click="$router.back()"
        >返回上页</van-button>
      </div>
      <van-button
        round
        type="danger"
        class="bottom-button"
        color="#999"
        to="/"
      >返回首页</van-button>
    </van-empty>
  </div>
</template>
<script>
export default {
  data() {
    return {
      errValue: '',
    }
  },
  created() {
    this.errValue = this.$route.query.msg
  },
}
</script>
<style lang="scss" scoped>
.bottom-button {
  width: 160px;
  height: 40px;
}
</style>